/* @ngInject */

export default () => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function RefinanceAnalysis(
    refinance,
    estimatedExitFees,
    estimatedEntryFees,
    refinanceCost,
    refinanceFunding,
    refinanceBenefit,
    reasonsToRefinance,
    isEdit
  ) {
    this.refinance = refinance;
    this.estimatedExitFees = estimatedExitFees;
    this.estimatedEntryFees = estimatedEntryFees;
    this.refinanceCost = refinanceCost;
    this.refinanceFunding = refinanceFunding;
    this.refinanceBenefit = refinanceBenefit;
    this.reasonsToRefinance = reasonsToRefinance;
    this.isEdit = isEdit;

    if (!this.refinanceBenefit?.cashback) {
      this.refinanceBenefit.cashback = 0;
    }
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  RefinanceAnalysis.Blank = function () {
    return RefinanceAnalysis.Build({
      refinance: {
        refinancingLoans: 0,
        additionalFundsRequested: 0
      },
      estimatedExitFees: {
        discharge: 0,
        deferredEstablishment: 0,
        breakCosts: 0,
        otherAssociatedExitCosts: 0
      },
      estimatedEntryFees: {
        totalBank: 0,
        lmi: 0,
        mortgageRegistration: 0,
        otherAssociatedEntryCosts: 0
      },
      refinanceCost: {
        onceOffRefinance: 0
      },
      refinanceFunding: {
        totalFundsRequired: 0,
        requiredLoanAmount: 0,
        surplusCustomerContribution: 0
      },
      refinanceBenefit: {
        interestRate: {
          current: 0,
          proposed: 0
        },
        loanTermRemaining: {
          current: 0,
          proposed: 0
        },
        monthlyHomeLoanRepayment: {
          current: 0,
          proposed: 0
        },
        annualOngoingFees: {
          current: 0,
          proposed: 0
        },
        annualBenefit: 0,
        cashback: 0,
        isCashbackEdited: false,
        savingsOverLoanTerm: 0,
        additionalMonthlyRepayment: 0,
        newCalculatedLoanTerm: 0,
        savingsOverLoanTermWithAdditionalMonthlyRepayment: 0
      },
      reasonsToRefinance: {
        overallAnnualSavingInterestAndFees: false,
        overallRepaymentSavingsMonthly: false,
        betterMeetsConsumersNeedsAndObjectives: false,
        lenderPolicy: false,
        other: false,
        otherComments: ''
      },
      isEdit: false
    });
  };
  RefinanceAnalysis.Build = function (data) {
    return new RefinanceAnalysis(
      data.refinance
        ? data.refinance
        : {
            refinancingLoans: 0,
            additionalFundsRequested: 0
          },
      data.estimatedExitFees
        ? data.estimatedExitFees
        : {
            discharge: 0,
            deferredEstablishment: 0,
            breakCosts: 0,
            otherAssociatedExitCosts: 0
          },
      data.estimatedEntryFees
        ? data.estimatedEntryFees
        : {
            totalBank: 0,
            lmi: 0,
            mortgageRegistration: 0,
            otherAssociatedEntryCosts: 0
          },
      data.refinanceCost
        ? data.refinanceCost
        : {
            onceOffRefinance: 0
          },
      data.refinanceFunding
        ? data.refinanceFunding
        : {
            totalFundsRequired: 0,
            requiredLoanAmount: 0,
            surplusCustomerContribution: 0
          },
      data.refinanceBenefit
        ? data.refinanceBenefit
        : {
            interestRate: {
              current: 0,
              proposed: 0
            },
            loanTermRemaining: {
              current: 0,
              proposed: 0
            },
            monthlyHomeLoanRepayment: {
              current: 0,
              proposed: 0
            },
            annualOngoingFees: {
              current: 0,
              proposed: 0
            },
            annualBenefit: 0,
            cashback: 0,
            isCashbackEdited: false,
            savingsOverLoanTerm: 0,
            additionalMonthlyRepayment: 0,
            newCalculatedLoanTerm: 0,
            savingsOverLoanTermWithAdditionalMonthlyRepayment: 0
          },
      data.reasonsToRefinance
        ? data.reasonsToRefinance
        : {
            overallAnnualSavingInterestAndFees: false,
            overallRepaymentSavingsMonthly: false,
            betterMeetsConsumersNeedsAndObjectives: false,
            lenderPolicy: false,
            other: false,
            otherComments: ''
          },
      data.isEdit ? data.isEdit : false
    );
  };

  return RefinanceAnalysis;
};
